var map = {
	"./articles.jpg": "O3OV",
	"./buy.jpg": "WJFQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "t1MX";


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.jpg$
// module id = t1MX
// module chunks = 0